// types
import { i18nEaiBalanceGroups } from 'models/i18n';

// ==============================|| I18N EN BALANCE GROUPS ||============================== //

const enEaiBalanceGroups: i18nEaiBalanceGroups = {
  balanceGroupList: {
    searchInput: 'Enter EIC / name',
    columns: {
      name: 'Name',
      eic: 'EIC',
      emsPartyName: 'Market participant'
    }
  },
  balanceGroupProperties: {
    title: 'Characteristics',
    deviationSubCardTitle: 'Limit of speculation with SI of the balance group',
    limit: 'Limit of speculation [MWh]',
    period: 'Period',
    optimizedPeriodNumberSelectLabel:
      'Number of predicted and planned periods for AI',
    productionModelTitle: 'Nomination model of the balance group'
  },
  balanceGroupData: {
    title: 'Balance group data',
    basicInfo: 'Basic info'
  },
  balanceGroupDeliveryPointList: {
    title: 'Delivery point list',
    columns: {
      name: 'Name',
      eic: 'EIC',
      id: 'ID',
      actions: 'Actions'
    }
  },
  input: {
    eic: 'EIC',
    name: 'Balance group name',
    emsPartyName: 'Market participant'
  },
  validation: {
    'name-required': 'Balance group name is mandatory',
    'eic-required': 'EIC is mandatory',
    'eic-length': 'Length must be 16',
    'eic-available': 'EIC must be unique'
  }
};

export default enEaiBalanceGroups;
